/**
 * IronHUD Application JavaScript (ES Module Bootstrapper)
 */

import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import { ToastComponent } from './core/toast.js';
import { TimeComponent } from './core/time.js';
import { ChartComponent } from './core/charts.js';
import { DatePickerComponent } from './core/datepicker.js';
import { LayoutComponent } from './core/layout.js';
import { MetricInputComponent, StepperInputComponent } from './core/inputs.js';
import { WorkoutBuilderComponent, SortableListComponent } from './features/workout.js';
import { FoodSearchComponent } from './features/diet.js';
import { MetricsComponent } from './features/metrics.js';
import { WodHeroComponent } from './features/dashboard.js';
import { TrainingComponent } from './features/training.js';
import { BiometricSlider } from './core/slider.js';

// Register Alpine Components
const registerComponents = () => {
    if (!window.Alpine) return;

    window.Alpine.plugin(focus);
    window.Alpine.plugin(collapse);

    window.Alpine.data('layout', LayoutComponent);
    window.Alpine.data('metricInput', MetricInputComponent);
    window.Alpine.data('stepperInput', StepperInputComponent);
    window.Alpine.data('metrics', MetricsComponent);
    window.Alpine.data('wodHero', WodHeroComponent);
    window.Alpine.data('trainingView', TrainingComponent);
    window.Alpine.data('biometricSlider', BiometricSlider);
    window.Alpine.data('toastManager', ToastComponent);
    window.Alpine.data('timeFormatter', TimeComponent);
    window.Alpine.data('evolutionChart', ChartComponent);
    window.Alpine.data('datePicker', DatePickerComponent);
    window.Alpine.data('workoutBuilder', WorkoutBuilderComponent);
    window.Alpine.data('foodSearch', FoodSearchComponent);
    window.Alpine.data('sortableList', SortableListComponent);
};

// Orchestrate registration
if (window.Alpine) {
    registerComponents();
}

document.addEventListener('alpine:init', registerComponents);

document.addEventListener('DOMContentLoaded', () => {
    // Components are self-initializing via Alpine
});
